



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Data } from "@/data/data";
import { Product } from "@/data/productCategory/product/product";
import { Paper } from "@/data/productCategory/product/paper/paper";
import { Document } from "@/model/document2/document"
import { InsertionData } from "@/model/document2/insertionData/insertionData";
import { Design } from "@/model/document2/page/surface/design/design"
import { NumberLayer } from "@/model/document2/page/surface/design/layer/numberLayer"
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer"

import Header from "@/commonComponents/header/header.vue";
import TopController from "./topController/topController.vue";
import RightController from "./rightController/rightController.vue";
import DesignView from "./designView/designView.vue";
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
import SelectOpenStorageModal from "@/commonComponents/alertModal/selectOpenStorageModal/selectOpenStorageModal.vue";
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import AfterLoadCsvModal from "@/commonComponents/alertModal/afterLoadCsvModal/afterLoadCsvModal.vue";
import InsertionModal2 from "@/commonComponents/alertModal/insertionModal2/insertionModal2.vue";

import { UuidHelper } from '@/helper/uuidHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { MessageCenter } from '@/model/messageCenter/messageCenter';

import * as def from "@/definitions";
@Component({
    components: 
    {
        Header,
        TopController,
        RightController,
        DesignView,
        FileOpen,
        SelectOpenStorageModal,
        Tutorial,
        License,
        AfterLoadCsvModal,
        InsertionModal2
    }
})
export default class SelectInsertionDesign extends Vue 
{
    private selectedIndex = 0;

    selectOpenStorageModalShown = false;
    insertionModalShown = false;

    isTutorial = false;
    isLicense = false;

    nextPage = "/InsertionEditor";

    private mounted(){
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("selectInsertionDesignTutorial") != true){
            this.isTutorial = true;
        }

        var messageCenter = this.$store.getters.messageCenter as MessageCenter;
        messageCenter.subscribe(this, "to_insertion_with_design", this.toInsertionWithDesign);
    }

    destroyed() 
    {
        var messageCenter = this.$store.getters.messageCenter as MessageCenter;
        messageCenter.unsubscribe(this, "to_insertion_with_design");
    }

    toInsertionWithDesign(parameter : any)
    {
        var link = parameter["link"];
        DebugHelper.trace("toInsertionWithDesign link: " + link);
        this.nextPage = link;

        var modal = this.$refs.insertionModal as InsertionModal2;
        modal.open((button) =>
        {
            if(button == "create")
            {
                // 表データなし
                this.goNext(false, link);
            }
            else if(button == "import")
            {
                // 読み込み
                this.goNext(true, link);
            }
        });
    }

    //---データ---//
    get rootData(): Data {
        return this.$store.getters.data;
    }

    private get document() : Document
    {
        return this.$store.getters.document;
    }

    private get insertionDocument() : Document | null
    {
        return this.$store.getters.userConfig.insertionDocument;
    }

    get selectedProduct(): Product 
    {
        return this.rootData.selectedProduct;
    }

    get selectedPaper(): Paper {
        return this.rootData.selectedPaper;
    }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    // デザインリスト
    // 読み込んだドキュメントのデザインをすべて表示する
    // 開いたドキュメントが差し込み設定の場合は最初のデザインだけ取得する
    private get designInfoList() : Array<{ design : Design, reverseDesign : Design | null, page : number, isReverse : boolean, position : number, index : number, id : string }>
    {
        var document = this.insertionDocument;
        if(document == null) { return []; }
        var array = new Array();
        var index = 0;
        var pageCount = document.useInsertion && document.pageCount > 0 ? 1 : document.pageCount;
        for(var pageIndex = 0; pageIndex < pageCount; ++pageIndex)
        {
            var page = document.pageList[pageIndex];
            {
                // オモテのみ得る
                var surface = page.getSurface(false);
                var reverseSurface = document.hasReverseSurface ? page.getSurface(true) : null;
                var designCount = document.useInsertion && page.designMaxNumber > 0 ? 1 : page.designMaxNumber;
                for(var pos = 0; pos < designCount; ++pos)
                {
                    var design = surface.getDesign(pos);
                    if(design != null)
                    {
                        // オブジェクトを含む場合のみ表示
                        if(design.hasAnyObject(false))
                        {
                            array.push({
                                design : design,
                                reverseDesign : reverseSurface != null ? reverseSurface.getDesign(pos) : null,
                                page : pageIndex,
                                isReverse : false,
                                position : pos,
                                index : index,
                                id : UuidHelper.getUuid()
                            });
                            index++;
                        }
                    }
                }
            }
        }

        if(array.length == 0)
        {
            // 1つもデザインがない場合は先に進めなくなるので新規デザインを作る
            if(document.pageCount > 0)
            {
                var firstPage = document.pageList[0];
                var firstSurface = firstPage.getSurface(false);
                var newDesign = firstSurface.createNewDesign(0);
                array.push({
                    design : newDesign,
                    reverseDesign : null,
                    page : 0,
                    isReverse : false,
                    position : 0,
                    index : 0,
                    id : UuidHelper.getUuid()
                });
            }
        }

        return array;
    }

    private selectDesign(index : number)
    {
        this.selectedIndex = index;
    }

    private onDoCommand(command : string, parameter : any)
    {
        if(command == "goNext")
        {
            // 次へ
            this.goNext(parameter.readTableFile);
        }
    }

    // 次へ
    // readTableFile : 表データを読み込みする
    private goNext(readTableFile : boolean, nextPage = "/InsertionEditor")
    {
        // 次のページ設定
        this.nextPage = nextPage;

        // ページが0の場合処理しない
        if(this.document.pageCount == 0) { return; }

        // if(readTableFile && !this.isDebugMode
        // || readTableFile && this.selectOpenStorageModalShown && this.isDebugMode)
        if(readTableFile && this.selectOpenStorageModalShown)
        {
            // 読み込み
            var fileOpen = this.$refs.fileOpen;
            if(fileOpen != null && fileOpen instanceof FileOpen)
            {
                fileOpen.open();
            }
        }
        // else if(readTableFile && !this.selectOpenStorageModalShown && this.isDebugMode)
        else if(readTableFile && !this.selectOpenStorageModalShown)
        {
            this.selectOpenStorageModalShown = true;
        }
        else
        {
            // 差し込みへ
            this.toInsertion();
        }
    }

    // ファイル読み込み
    private onFileRead(text : string, fileType : string, readType : string)
    {
        DebugHelper.trace(text);
        this.toInsertion(true, text, fileType, readType);
    }

    // 差し込みへ
    private toInsertion(applyfile : boolean = false, text : string = "", fileType : string = "", readType : string = "")
    {
        DebugHelper.trace(text);
        DebugHelper.trace(fileType);
        DebugHelper.trace(readType);
        var selectedInfo = this.designInfoList[this.selectedIndex];
        if(0 <= this.selectedIndex && this.selectedIndex < this.designInfoList.length)
        {
            // 選択したデザインを最初のデザインにセットする
            // まず決定したデザインを取得
            var design = selectedInfo.design;
            // このデザインをposition:0に移動する
            var firstPage = this.document.pageList[0];
            var firstSurface = firstPage.getSurface(false);
            firstSurface.setDesign(0, design);
            // 裏も移動する
            if(firstPage.hasReverse && selectedInfo.reverseDesign != null)
            {
                var reverseSurface = firstPage.getSurface(true);
                reverseSurface.setDesign(0, selectedInfo.reverseDesign);
            }

            // 最初のページとデザイン以外を全て削除する
            this.deleteAllWithoutFirst();
        }

        // 差し込みデータ新規作成
        this.document.insertionData = new InsertionData();
        // Rowの個数が0なら追加
        if(this.document.insertionData.getRowDataCount() == 0)
        {
            this.document.insertionData.addRowData();
        }

        // 差し込みオン
        this.document.useInsertion = true;


        // 読み込み元ダイアログを非表示にする
        this.selectOpenStorageModalShown = false;
        // 差し込みを自動適用するか選択する
        var modal = this.$refs.afterLoadCsvModal as AfterLoadCsvModal;
        modal.open((result : string) =>
        {
            if(result == "ok")
            {
                // デザインを元にして差し込みデータを再作成する
                var firstPage = this.document.pageList[0];
                var surfaceCount = firstPage.hasReverse ? 2 : 1;
                for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
                {
                    var firstSurface = firstPage.getSurface(surfaceIndex > 0);
                    var firstDesign = firstSurface.getDesign(0);
                    if(firstDesign != null)
                    {
                        this.document.insertionData = InsertionHelper.applyDesignToInsertionData(this.document.insertionData, firstDesign);
                    }
                }
            }

            if(applyfile)
            {
                // 表読み込み処理
                if(readType == "binary")
                {
                    // xlsx読み込み
                    var loadedData = InsertionData.createFromXlsx(text, this.document.insertionData);
                    this.document.insertionData = loadedData;
                }
                else
                {
                    // csv読み込み
                    var loadedData = InsertionData.createFromCsv(text, this.document.insertionData);
                    this.document.insertionData = loadedData;
                }

                if(this.document.insertionData.isFirstRowAsColumnName && this.document.insertionData.getRowDataCount() <= 1)
                {
                    // 1行目を列名にするが有効で、行数が1の場合は行がなくなってしまうので、1行目を列名にするをオフにする
                    this.document.insertionData.isFirstRowAsColumnName = false;
                }

                InsertionHelper.applyInsertionToFirstDesign(this.document);
            }

            // 再読み込みの可能性があるのでカレントを 0,0 に戻す
            this.document.selectedInsertionRow = 0;
            this.document.selectedInsertionColumn = 0;
            this.document.selectedInsertionWholeColumn = -1;

            // 差し込みデータを初期値まで埋める
            this.document.insertionData = InsertionHelper.addColumnDataToInitCount(this.document.insertionData);

            // 遷移
            this.$router.push(this.nextPage);
        });
    }

    // ページとデザインを最初を残してすべて削除する
    private deleteAllWithoutFirst()
    {
        // ページ削除
        if(this.document.pageCount > 1)
        {
            for(var pageIndex = this.document.pageCount - 1; pageIndex >= 1; --pageIndex)
            {
                this.document.removePage(pageIndex);
            }
        }

        // 1ページ目において、デザインを削除
        if(this.document.pageCount > 0)
        {
            var firstPage = this.document.pageList[0];
            var surfaceCount = firstPage.hasReverse ? 2 : 1;
            for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
            {
                var surface = firstPage.getSurface(surfaceIndex > 0);
                if(firstPage.designMaxNumber > 1)
                {
                    for(var pos = 1; pos < firstPage.designMaxNumber; ++pos)
                    {
                        if(surface.getDesign(pos) != null)
                        {
                            surface.removeDesign(pos);
                        }
                    }
                }
            }
        }
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("selectInsertionDesignTutorial") != true;
    }

    // タブ

    private get currentTab() { return "/SelectInsertionDesign"; }
}
